import React from 'react';
import PropTypes from 'prop-types';

import { Card, Typography } from '../../../../components';
import * as S from './CancellationCard.styles';

export const CancellationCard = ({ role, booking }) => {
	return (
		<Card title="Cancellation" transparentHeaderBorder={true}>
			<S.Wrapper>
				<div className="grid-line">
					<div className="grid-line__info-item">
						<Typography tag="h6" weight="semibold">
							Cancelled By
						</Typography>
						<Typography tag="p">{booking.declineUser?.firstName ? `${booking.declineUser?.firstName} ${booking.declineUser?.lastName}` : `${booking.cancelUser?.firstName} ${booking.cancelUser?.lastName}`}</Typography>
					</div>
					<div className="grid-line__info-item">
						<Typography tag="h6" weight="semibold">
							Reason
						</Typography>
						<Typography tag="p">{booking.declineReason}</Typography>
					</div>
					<div className="grid-line__info-item">
						<Typography tag="h6" weight="semibold">
							Message
						</Typography>
						<Typography tag="p">{booking.declineNotes}</Typography>
					</div>
				</div>
			</S.Wrapper>
		</Card>
	);
};

CancellationCard.propTypes = {
	booking: PropTypes.shape(),
	role: PropTypes.string,
};
